'use client'
import Footer from '@/components/Footer';
import usePhoneNumber from '@/hooks/usePhoneNumber';
import 'swiper/css';
import 'swiper/css/pagination';
import MainMenu from '@/components/MainMenu';
import Image from 'next/image'
import Link from 'next/link'
import { useCallback, useEffect, useState } from 'react';
import { sendRequest, sendRequestNoToken } from '@/utils/apiService';
import { SpinningSkeletonLoader } from '@/components/skeleton/SpinningSkeleton';
import { Article, formatDateTime } from '@/utils/types';
import Pagination from '@/components/Pagination';





export default function Page() {
  const { phoneNumber, isCookieLoading } = usePhoneNumber();
  const [totalPages, setTotalPages] = useState<number>(1);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [isLoading, setIsLoading] = useState(true);
    const [result, setResult] = useState<Article[]>([]);

    const handlePageChange = (page: number) => {
        fetchData(page)
    };


    const fetchData = useCallback((currentPage: number) => {
        setCurrentPage(currentPage);
        setIsLoading(true);
        const params = new URLSearchParams({
            page: currentPage.toString(),
        });
        sendRequestNoToken("GET", `/api/mydesk/list/?${params.toString()}`, null)
            .then((data) => {
                setResult(data.results);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);


    useEffect(() => {
       fetchData(1)
    }, [fetchData]);


  return (
	<main className="flex flex-col items-center justify-between overflow-hidden">
	  <MainMenu isLoading={isCookieLoading} phoneNumber={phoneNumber} scrollIndicatorEnabled={true}/>
        <section className="text-start pt-10 pb-0 md:pt-24 w-screen justify-start bg-gradient-to-b from-white to-gradient-start  dark:from-purple-700 dark:to-dark-800">
				<div className='container my-20 text-center'>
					<div>
						<div className='text-4xl md:text-6xl font-semibold'>
							my<span className='text-purple-500'>Desk</span>
						</div>
						<div className='text-lg mt-10 max-w-[600px] mx-auto'>
                        Салбар бүрийн мэргэжилтнүүд мэргэжлийнхээ талаарх ойлголт болон ажлын туршлагаа хуваалцсан ярилцлагыг уншаарай. 
						</div>
					</div>
				</div>
			</section>
            <section className='min-h-[50vh] w-full bg-gradient-start pb-10 dark:bg-dark-800'>
            <div className='container flex flex-col space-y-8 md:space-y-4'>
            {isLoading ? (
                    <div className='w-full flex justify-center my-8'><SpinningSkeletonLoader /></div>
                ) : (<>
                        {result.map((item, index) => (
                        <Link href={`/mydesk/${item.url}`} key={index} className={`max-w-[700px] ${index%2==1 && "self-end"}`}>
                            <div className={`flex flex-row items-center space-x-4 ${index%2==1 && ("justify-end")}`}>
                                <div className='w-[40px] h-[40px] flex items-center justify-center bg-white  rounded-full'>
                                    <Image
                                        src="/images/short-logo.png"
                                        width={20}
                                        height={20}
                                        alt={''}
                                        className=""
                                    />
                                </div>
                                <div className='flex flex-col space-y-0'>
                                    <div className='text-xs text-career-dark-300 font-semibold'>{item.author}</div>
                                    <div className='text-xs text-career-dark-300 font-semibold'>{formatDateTime(item.publish_datetime)} ({item.read_minute} минут)</div>
                                </div>
                            </div>
                            <div className={`bg-white dark:bg-dark-600 p-10 mt-3 rounded-b-2xl ${index%2==1 ? "rounded-tl-2xl" : "rounded-tr-2xl"} shadow-sm`}>
                                <div className='flex md:flex-row flex-col md:space-x-4 text-center md:text-start justify-between'>
                                    <div>
                                        <div className='text-purple-500 dark:text-purple-400 font-semibold text-sm'>{item.subtitle}</div>
                                        <div className='font-semibold text-xl'>{item.title}</div>
                                    </div>
                                    <div className='flex justify-center mt-4 max-w-[200px]'>
                                        <Image
                                            src={item.image_url}
                                            width={200}
                                            height={200}
                                            alt={''}
                                            className="rounded-xl"
                                        />
                                    </div>
                                </div>
                                
                            </div>
                        </Link>
                        ))}
                    </>
                )}

                <div className="pt-10 flex justify-center">
                    <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} totalPages={totalPages} onPageChange={handlePageChange} isLoading={isLoading} />
                </div>
                </div>
            </section>
	  <Footer />
	</main>
  )
}
